import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Button, notification, Spin } from 'antd';
import imeilogo from '../../assets/report/gearvu-logo.png';
import './ImeiFinder.css';
import errorSound from '../../assets/sounds/error-sound.mp3';
import Sidebar from '../Sidebar/Sidebar';
import ImeiFinderReportTable from './ImeiFinderReportTable';

function ImeiScript() {
  const [imei, setImei] = useState('');
  const [imeiMap, setImeiMap] = useState({});
  const [loading, setLoading] = useState(true);
  const [isDataLoading, setIsDataLoading] = useState(false);
  const [isToView, setIsToView] = useState(false);
  const [tableData, setTableData] = useState([])

  const playErrorSound = () => {
    const audio = new Audio(errorSound);
    audio.play();
  };

  useEffect(() => {
    const fetchImeiData = async () => {
      try {
        const response = await axios.get('/api/reports/dashboard');
        const fetchedImeiMap = {};

        response.data.reports.forEach((report) => {
          fetchedImeiMap[report.data.report.IMEI] = report.data.report.reportid;
        });

        setImeiMap(fetchedImeiMap);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching IMEI data:', error);
        notification.error({
          message: 'Error',
          description: 'Failed to load IMEI data. Please try again later.',
          placement: 'topRight',
        });
        setLoading(false);
      }
    };

    fetchImeiData();
  }, []);


  const formatSessionData = (reportData) => {
    const grading = reportData.grading || {};
    const condition = grading.condition || {};
    const blacklistCheck = reportData.blacklistCheck || {};
    const rawResponse = blacklistCheck.RawResponse || {};
    const allPrices = reportData.allPrices || {};
    const device = reportData.device || {};
    const status = reportData.status || {};

    return {
      brand: device.brand || 'N/A',
      model: device.model || 'N/A',
      imei: device.imei || 'N/A',
      capacity: device.capacity || 'N/A',
      carrier: device.carrier || 'N/A',
      sessionId: reportData.sessionId || 'N/A',
      date: reportData.date || 'N/A', // You can format if needed
      endMethod: reportData.endMethod || 'N/A',
      agent: reportData.agent || 'N/A',
      grade: grading.grade || 'N/A',
      functional: condition?.NotFunctional ? 'Needs Attention' : 'Fully Functional',
      offerPrice: reportData.price || 0,
      newPrice: allPrices.new || 0,
      goodPrice: allPrices.good || 0,
      badPrice: allPrices.bad || 0,
      recyclePrice: allPrices.recycle || 0,
      ScreenIssue:
        condition.BrokenScreenDisplay || condition.ScratchesDisplayBackglass
          ? 'Issue Found'
          : 'No',
      BodyDamage: condition.BrokenBackglass || condition.Dents || condition.Cracks ? 'Issue Found' : 'No',
      BatteryIssue: condition.BatteryIssue || 'N/A', // Adjust if your API gives battery info
      CameraIssue: condition.BrokenCamera || condition.BrokenBackglassCamera ? 'Issue Found' : 'No',
      blacklistStatus: blacklistCheck.Remarks || 'N/A',
      responseStatus: rawResponse.responsestatus || 'N/A',
      greylistStatus: rawResponse.greyliststatus || 'N/A',
      response:status || 'N/A',
    };
  };

  const handleSubmit = async (e) => {
    setIsDataLoading(true)
    e.preventDefault();

    if (imei) {
      try {
        const response = await axios.get(
          `https://live.callcenter.buybackbooth.com/Scripts/Gearvana/CC_GetSessionFromIMEI.php?imei=${imei}`
        );

        if (response.data.status === 'error') {
          playErrorSound();
          notification.error({
            message: 'No IMEI number record found!',
            description: 'No IMEI number record found! Please enter a correct IMEI number.',
            placement: 'topRight',
            duration: 5,
            style: { fontSize: '16px', color: '#FF4D4F' },
          });
          return;
        }
        const formatted = formatSessionData(response.data.data[0]);
        setTableData([formatted])
        setIsToView(true)
        window.scrollTo({
          top: document.body.scrollHeight,
          behavior: 'smooth'
        });
        // window.open(`/live-report/${imei}`, '_blank');
      } catch (error) {
        console.error('Error fetching IMEI session:', error);
        notification.error({
          message: 'Error',
          description: 'Failed to check IMEI data. Please try again later.',
          placement: 'topRight',
        });
      } finally {
        setIsDataLoading(false)
      }
    }
  };

  const handleInputChange = (e) => {
    const numericValue = e.target.value.replace(/\D/g, '');
    setImei(numericValue);
  };

  const viewReport = () => {
    window.open(`/live-report/${imei}`, '_blank');
  }

  // if (loading) {
  //   return (
  //     <div
  //       style={{
  //         display: 'flex',
  //         justifyContent: 'center',
  //         alignItems: 'center',
  //         height: '100vh',
  //       }}
  //     >
  //       <img
  //         src="https://i.pinimg.com/originals/65/ba/48/65ba488626025cff82f091336fbf94bb.gif"
  //         alt="Loading..."
  //       />
  //     </div>
  //   );
  // }

  return (
    <div className="App" style={{ display: 'flex' }}>
      <div className='imie-finder-sidebar'>
        <Sidebar />
      </div>

      <div className="imei-finder" >
        
          <form onSubmit={handleSubmit}>
            <div>
              <span>IMEI NUMBER</span>
              <input
                size="1"
                type="text"
                name="imei"
                id="imei"
                value={imei}
                onChange={handleInputChange}
              />
            </div>
            <br />
            <button loading={isDataLoading} type="submit">{isDataLoading?'loading....': 'Search'}</button>
          
          </form>
        <div className='imei-finder-table'>
          <ImeiFinderReportTable data={tableData} onViewReport ={()=>viewReport} imei={imei} isToView={isToView}/>
        </div>




      </div>

    </div>
  );
}

export default ImeiScript;

